// Shared date/time formatting helpers (pt-BR / Brasília)

// Formats a raw <input type="datetime-local"> string ("YYYY-MM-DDTHH:mm") literally,
// without any timezone re-interpretation (the value already represents local wall-clock time).
export const formatEta = (etaStr) => {
  if (!etaStr) return '';
  const match = String(etaStr).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (match) {
    const [, , month, day, hour, min] = match;
    return `${day}/${month} ${hour}:${min}`;
  }
  const d = new Date(etaStr);
  if (isNaN(d.getTime())) return etaStr;
  return d.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};
